import type { TrailDefinition, TrailContext } from './types'

interface SmokeParticle {
  x: number
  y: number
  vx: number
  vy: number
  life: number
  maxLife: number
  radius: number
  startRadius: number
}

const MAX_PARTICLES = 50

export const smoke: TrailDefinition = {
  id: 'smoke',
  name: 'Smoke',

  init() {
    return [] as SmokeParticle[]
  },

  update(state: unknown, ctx: TrailContext) {
    const particles = state as SmokeParticle[]
    const dt = ctx.deltaTime / 1000

    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(2, MAX_PARTICLES - particles.length)
      for (let i = 0; i < spawnCount; i++) {
        const r = 6 + Math.random() * 10
        particles.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 6,
          y: ctx.mouseY + (Math.random() - 0.5) * 6,
          vx: (Math.random() - 0.5) * 20,
          vy: -(15 + Math.random() * 25),
          life: 1,
          maxLife: 0.6 + Math.random() * 0.5,
          radius: r,
          startRadius: r
        })
      }
    }

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i]
      p.life -= dt / p.maxLife
      p.x += p.vx * dt
      p.y += p.vy * dt
      p.vx += (Math.random() - 0.5) * 30 * dt
      p.vy *= 0.99
      p.radius = p.startRadius * (1 + (1 - p.life) * 1.5)

      if (p.life <= 0) {
        particles.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const particles = state as SmokeParticle[]
    const c = ctx.ctx

    for (const p of particles) {
      const alpha = Math.max(0, p.life) * 0.25

      const gradient = c.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.radius)
      gradient.addColorStop(0, `rgba(200, 200, 210, ${alpha})`)
      gradient.addColorStop(0.6, `rgba(180, 180, 190, ${alpha * 0.5})`)
      gradient.addColorStop(1, 'transparent')

      c.fillStyle = gradient
      c.fillRect(p.x - p.radius, p.y - p.radius, p.radius * 2, p.radius * 2)
    }
  }
}
